export default "__VITE_ASSET__CohPemMV__"